import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512 1024A512 512 0 0115.36 388.332a512 512 0 01935.385-139.815 508.062 508.062 0 0157.895 387.545A512 512 0 01512 1024zm0-998.4a486.4 486.4 0 00-118.154 959.015 486.006 486.006 0 00590.77-354.461 486.006 486.006 0 00-354.462-590.77A488.763 488.763 0 00512 25.6zM472.615 768v-98.462h111.853v-45.292H472.615v-69.71h70.105a228.825 228.825 0 0063.015-8.271 144.935 144.935 0 0050.807-25.207 120.91 120.91 0 0033.87-42.535 136.665 136.665 0 0012.603-60.258 138.634 138.634 0 00-11.815-59.471 112.64 112.64 0 00-32.69-39.385 139.815 139.815 0 00-50.018-24.418 244.185 244.185 0 00-64.59-7.877H416.295v221.341h-49.23v48.443h49.23v70.105h-49.23v42.535h49.23V768zm71.287-262.302h-71.287V333.194h71.287a124.85 124.85 0 0174.436 21.268 74.83 74.83 0 0127.57 64.59 78.77 78.77 0 01-27.57 66.166 118.154 118.154 0 01-75.224 21.662zM472.615 768v-98.462h111.853v-45.292H472.615v-69.71h70.105a228.825 228.825 0 0063.015-8.271 144.935 144.935 0 0050.807-25.207 120.91 120.91 0 0033.87-42.535 136.665 136.665 0 0012.603-60.258 138.634 138.634 0 00-11.815-59.471 112.64 112.64 0 00-32.69-39.385 139.815 139.815 0 00-50.018-24.418 244.185 244.185 0 00-64.59-7.877H416.295v221.341h-49.23v48.443h49.23v70.105h-49.23v42.535h49.23V768zm71.287-262.302h-71.287V333.194h71.287a124.85 124.85 0 0174.436 21.268 74.83 74.83 0 0127.57 64.59 78.77 78.77 0 01-27.57 66.166 118.154 118.154 0 01-75.224 21.662z"
});

function SvgRub(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "RUB_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRub);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'RUBOutlined';

export default KuFoxIcons;
